// JsaEmergencyEquipment
export class JsaEmergencyEquipment {
  constructor(data = {}) {
    this.fireExtinguisherType = data.fire_extinguisher_type || "";
    this.fireExtinguisherInspectionDate =
      data.fire_extinguisher_inspection_date || "";
    this.fireHydrantLocation = data.fire_hydrant_location || "";
    this.emergencyEyewashShowerLocation =
      data.emergency_eyewash_shower_location || "";
    this.windDirection = data.wind_direction || "";
    this.otherEmergencyEquipment = data.other_emergency_equipment || "";
  }

  updateFireExtinguisherType(value) {
    if (!value) {
      this.fireExtinguisherType = "";
    } else {
      this.fireExtinguisherType = value;
    }
  }

  updateFireExtinguisherInspectionDate(date) {
    if (!date) {
      this.fireExtinguisherInspectionDate = "";
    } else {
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = date.getFullYear();
      this.fireExtinguisherInspectionDate = `${year}-${month}-${day}`;
    }
  }

  updateFireHydrantLocation(value) {
    if (!value) {
      this.fireHydrantLocation = "";
    } else {
      this.fireHydrantLocation = value;
    }
  }

  updateEmergencyEyewashShowerLocation(value) {
    if (!value) {
      this.emergencyEyewashShowerLocation = "";
    } else {
      this.emergencyEyewashShowerLocation = value;
    }
  }

  updateWindDirection(value) {
    if (!value) {
      this.windDirection = "";
    } else {
      this.windDirection = value;
    }
  }

  updateOtherEmergencyEquipment(value) {
    if (!value) {
      this.otherEmergencyEquipment = "";
    } else {
      this.otherEmergencyEquipment = value;
    }
  }

  // To json for sending to the database
  toJson() {
    return {
      fire_extinguisher_type: this.fireExtinguisherType,
      fire_extinguisher_inspection_date: this.fireExtinguisherInspectionDate,
      fire_hydrant_location: this.fireHydrantLocation,
      emergency_eyewash_shower_location: this.emergencyEyewashShowerLocation,
      wind_direction: this.windDirection,
      other_emergency_equipment: this.otherEmergencyEquipment,
    };
  }

  // Helper for single and multi-field patches to be sent via websocket
  toPatch(fields, jsaId, action = "update") {
    const fieldMap = {
      fireExtinguisherType: "fire_extinguisher_type",
      fireExtinguisherInspectionDate: "fire_extinguisher_inspection_date",
      fireHydrantLocation: "fire_hydrant_location",
      emergencyEyewashShowerLocation: "emergency_eyewash_shower_location",
      windDirection: "wind_direction",
      otherEmergencyEquipment: "other_emergency_equipment",
    };

    const patch = {
      patch_type: "jsa_emergency_equipment",
      jsa_id: jsaId,
      action,
    };

    for (const [key, value] of Object.entries(fields)) {
      const dbField = fieldMap[key];
      if (dbField) {
        patch[dbField] = value;
      }
    }

    return patch;
  }
}
